import _axios from '@/plugins/axios';
import { UsersError } from '@/lib/Errors';

export default {
	async getConsumableCatalogs () {
		const response = await _axios.get('inventory/consumableModel');
		if (response.data.resFlag) {
			return response.data.data;
		} else if (response.data.msg === 'No inventory consumable models found.') {
			return [];
		}
		throw new UsersError('Error getting consumable models!');
	},
	async getConsumableCatalogById (id) {
		const response = await _axios.get(`inventory/consumableModel/${id}`);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error getting consumable model!');
	},
	async addConsumableCatalog (body) {
		const response = await _axios.post('inventory/consumableModel', body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error adding consumable model!');
	},
	async editConsumableCatalog (body) {
		const response = await _axios.put(`inventory/consumableModel/${body.id}`, body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error editing consumable model!');
	},
	async deleteConsumableCatalogs (id) {
		const response = await _axios.delete(`inventory/consumableModel/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error deleting consumable model!');
	},
	async getInventoryConsumableCategoryOptions () {
		const response = await _axios.get('inventory/consumableModel/getInventoryConsumableCategoryOptions');
		if (response.data.resFlag) {
			return response.data.data;
		} else if (response.data.msg === 'No inventory consumable models found.') {
			return [];
		}
		throw new UsersError('Error getting consumable models!');
	},
	async getInventoryUnitOfMeasureOptions () {
		const response = await _axios.get('inventory/consumableModel/getinventoryunitofmeasureoptions');
		if (response.data.resFlag) {
			return response.data.data;
		} else if (response.data.msg === 'No inventory consumable models found.') {
			return [];
		}
		throw new UsersError('Error getting consumable models!');
	},

};
